module.exports = __webpack_public_path__ + "static/ui-1-80385200c32b80fef9a1c3afd448516a.png";